// extracted by mini-css-extract-plugin
export default {"text":"noGroupPage__text___lPTV4"};